import { z } from 'zod';
export const AssistantIdParamsSchema = z.object({
    assistantId: z.uuid(),
});
export const AssistantDefinitionIdParamsSchema = z.object({
    assistantDefinitionId: z.uuid(),
});
//# sourceMappingURL=params.js.map